module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sc-4691653cefd138906e7bca113ba4818b.svg";